import axios from "axios";
import BASE_URL from "../_helpers/constants";
import { readCurrentUser } from "../_helpers/currentUser";

// Pooled inbox SP4 — You're in and the seven questions (contract:
// Astra-Backend docs/superpowers/specs/2026-10-03-pooled-inbox-sp4-questionnaire-design.md
// § The intake contract). The onboarding.services.js style: each returns the
// axios response and throws on a non-2xx; callers read `res.data` and
// `err.response.data`.
const authHeaders = () => ({
  Authorization: `Bearer ${readCurrentUser()?.token ?? ""}`,
});
const page = (pageKey) => encodeURIComponent(pageKey);

// You're in, either button: advances past trial_start; { stage, routeFor }.
export const continueWelcome = () =>
  axios.post(
    `${BASE_URL}/onboarding/welcome/continue`,
    {},
    { headers: authHeaders() },
  );

// The pages, the answers, progress and the next page. Staff pass the client.
export const getIntake = (clientId) =>
  axios.get(`${BASE_URL}/onboarding/intake`, {
    headers: authHeaders(),
    ...(clientId ? { params: { clientId } } : {}),
  });

// One page's answers (wizard and Questions page). The Questions page adds
// `edit: true` only when it clears a page (R183); the wizard never does.
export const saveIntakePage = (pageKey, body) =>
  axios.post(`${BASE_URL}/onboarding/intake/${page(pageKey)}`, body, {
    headers: authHeaders(),
  });

// Leave a page blank: marks it complete, writes no answer.
export const skipIntakePage = (pageKey) =>
  axios.post(
    `${BASE_URL}/onboarding/intake/${page(pageKey)}/skip`,
    {},
    { headers: authHeaders() },
  );

// Plaid-derived figures for Q5/Q6, only when the plaid consent is on.
export const getPlaidSuggestions = (pageKey) =>
  axios.get(
    `${BASE_URL}/onboarding/intake/plaid-suggestions/${page(pageKey)}`,
    {
      headers: authHeaders(),
    },
  );
